import { call, fork, put, take, select } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';
import { refNumber } from '../refNumber';

function* postRequestHire(hireRequest) {
    const response = yield call(api.postRequestHire, hireRequest);

    if (response.status === 200) {
        yield put({
            type: actionTypes.POST_HIRE_REQUEST.SUCCESS,
            data: response.data,
            hireRequest,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: `Success hire request - ${hireRequest.keyHireOrder + 1}`,
                message: `${response.data.message}`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield call(refNumber, response.data);
        return response;
    }
    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: `Error hire request - ${hireRequest.keyHireOrder + 1}`,
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });
    
    yield put({
        type: actionTypes.POST_HIRE_REQUEST.FAILURE,
        errors: response.errors,
        hireRequest,
    });
    

    return response;
}

export function* watchPostRequestHire() {
    while (true) {
        const { hireRequest } = yield take(actionTypes.POST_HIRE_REQUEST.REQUEST);
        yield fork(postRequestHire, hireRequest);
    }
}

function* getRequestsHire(filter) {
    const response = yield call(api.getHiresList, filter);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_HIRE_ORDERS.SUCCESS,
            data: response,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_HIRE_ORDERS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetRequestsHire() {
    while (true) {
        const { filter } = yield take(actionTypes.GET_HIRE_ORDERS.REQUEST);
        yield fork(getRequestsHire, filter);
    }
}

function* deleteRequestHire(hireId) {
    const response = yield call(api.deleteRequestHire, hireId);
    if (response.status === 200) {
        // const store = yield select();

        yield put({
            type: actionTypes.DELETE_HIRE_REQUEST.SUCCESS,
            hireId,
            // email: store.user.user.email,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: hireId,
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.DELETE_HIRE_REQUEST.FAILURE,
        hireId,
        error: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: hireId,
            autoDismiss: 2,
        },
    });

    return response;
}

export function* watchDeleteRequestHire() {
    while (true) {
        const { hireId } = yield take(actionTypes.DELETE_HIRE_REQUEST.REQUEST);
        yield fork(deleteRequestHire, hireId);
    }
}

export default [watchPostRequestHire, watchGetRequestsHire];



// WEBPACK FOOTER //
// ./app/sagas/hires/requests.js